<template>
  <div :class="$attrs.class">
    <Datepicker
      ref="dateinput"
      calendarClassName="dp-custom-calendar"
      menuClassName="dp-custom-menu"
      v-model="inputValue"
      modelType="dd-MM-yyyy"
      weekStart="0"
      autoApply
      inline
      close-on-scroll
      locale="pt-BR"
      :clearable="false"
      :enableTimePicker="false"
      :class="{ error: error }"
    >
      <template #dp-input="{ value, onInput, onEnter, onTab, onClear }"></template>
    </Datepicker>

    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid';
import { mask } from 'vue-the-mask';
import Datepicker from '@vuepic/vue-datepicker';
import Popover from '@/Shared/Components/Popover';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
  inheritAttrs: false,
  emits: ['update:modelValue'],

  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`;
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    info: String,
    error: String,
    label: String,
    modelValue: String,
  },

  components: {
    Datepicker,
    Popover,
  },

  directives: {
    mask,
  },

  data() {
    return {
      inputValue: '',
      dateMask: '##/##/####',
    };
  },

  created() {
    if (this.$props.modelValue) {
      const [year, month, day] = this.$props.modelValue.split('-');
      if (year && month) {
        const currentDay = day ? day : new Date().getDate().toString().padStart(2, '0');
        this.inputValue = `${currentDay}-${month}-${year}`;
      }
    }
  },

  watch: {
    inputValue(newValue) {
      if (newValue && newValue.match(/^\d{2}-\d{2}-\d{4}$/)) {
        const [day, month, year] = newValue.split('-');
        const formattedDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        this.$emit('update:modelValue', formattedDate);
      }
    },
    modelValue(newValue) {
      if (newValue) {
        const [year, month, day] = newValue.split('-');
        if (year && month) {
          const currentDay = day ? day : new Date().getDate().toString().padStart(2, '0');
          this.inputValue = `${currentDay}-${month}-${year}`;
        }
      }
    },
  },
};
</script>


<style>
.dp__main {
    @apply w-full;
}
.dp-custom-calendar .dp__calendar_header {
    @apply w-full;
}
.dp-custom-calendar .dp__calendar {
    @apply w-full;
}
.dp-custom-calendar .dp__calendar_item {
    @apply flex items-center text-center justify-center;
}
.dp-custom-calendar .dp__active_date {
  background-color: var(--color-primary);
}
.dp-custom-calendar .dp__today {
  border-color: var(--color-primary);
}
.dp-custom-menu {
    @apply w-full border-none focus:border-none;
}
.dot-date {
  @apply absolute bg-green-600 rounded-full;
  height: 7px;
  width: 7px;
  top: 2px
}
.dp-custom-menu .dp__overlay {
  @apply scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-200;
}

</style>
